import { getUiNumberFormat } from '../components/ui/number-format-context.js';

function settings() {
	const f = getUiNumberFormat();
	return {
		decimalSep: f.decimalSeparator,
		groupSep: f.groupSeparator,
		decimalsQty: f.decimalsQuantity
	};
}

function addGroupSeparators(integerPart: string, groupSep: string): string {
	if (!groupSep) return integerPart;
	return integerPart.replace(/\B(?=(\d{3})+(?!\d))/g, groupSep);
}

export function formatNumber(value: number | null, decimals?: number): string {
	if (value == null) return '';

	const { decimalSep, groupSep, decimalsQty } = settings();
	const qty = decimals ?? decimalsQty;

	const abs = Math.abs(value);
	const fixed = abs.toFixed(qty);
	const [intPart, decPart] = fixed.split('.');

	const grouped = addGroupSeparators(intPart, groupSep);
	let result = qty > 0 ? `${grouped}${decimalSep}${decPart}` : grouped;
	if (value < 0) result = `-${result}`;
	return result;
}

export function formatMoney(amount: number | null, currencySymbol?: string): string {
	if (amount == null) return '';

	const sym = currencySymbol ?? getUiNumberFormat().currencySymbol;

	if (amount < 0) {
		return `- ${sym} ${formatNumber(Math.abs(amount))}`;
	}
	return `${sym} ${formatNumber(amount)}`;
}

export function parseNumber(str: string): number | null {
	if (!str || str === '-') return null;

	const { decimalSep, groupSep } = settings();

	let normalized = str;
	if (groupSep) {
		normalized = normalized.replaceAll(groupSep, '');
	}
	normalized = normalized.replace(decimalSep, '.');

	const parsed = parseFloat(normalized);
	return isNaN(parsed) ? null : parsed;
}

export function formatWithoutExponent(value: number): string {
	const text = String(value);
	const match = /^(-?)(\d)(?:\.(\d+))?e([+-]\d+)$/.exec(text);
	if (!match) return text;

	const [, sign, leadingDigit, fractionDigits = '', exponent] = match;
	const digits = leadingDigit + fractionDigits;
	const pointPosition = 1 + Number(exponent);

	if (pointPosition <= 0) return `${sign}0.${'0'.repeat(-pointPosition)}${digits}`;
	if (pointPosition >= digits.length) return `${sign}${digits}${'0'.repeat(pointPosition - digits.length)}`;
	return `${sign}${digits.slice(0, pointPosition)}.${digits.slice(pointPosition)}`;
}

export function formatForEditing(value: number | null): string {
	if (value == null) return '';
	const { decimalSep } = settings();
	return formatWithoutExponent(value).replace('.', decimalSep);
}
